// appSettingsRegistry.js
import CallQuantumSettingsFormFields, {
    CallQuantumSettingsSchema,
    CallQuantumSettingsValues,
} from "./CallQuantumSettings";
import CloudConnectionSettingsFormFields, {
    CloudConnectionSettingsSchema,
    CloudConnectionSettingsValues,
} from "./CloudConnectionSettings";
import ModelRunnerSettingsFormFields, {
    ModelRunnerSettingsSchema,
    ModelRunnerSettingsValues,
} from "./ModelRunnerSettings";
import RouteplannerSettingsFormFields, {
    RouteplannerSettingsSchema,
    RouteplannerSettingsValues,
} from "./RouteplannerSettings";
import UploadNameSettingsFormFields, {
    UploadNameSettingsSchema,
    UploadNameSettingsValues,
} from "./UploadNameSettings";

export const MODEL_RUNNER_APP_ID = "EOD5DkkuJaDgasEouNnd";
export const TRACK32_EXPORT_APP_ID = "969UwUrTR04CKrPAOHGb";
export const QUANTUM_EXPORT_APP_ID = "70UjAP1TL4dWWIYYv0M6";

export function appDependsOn(app, dependencyId, apps = []) {
    if (!app || !dependencyId) return false;

    const appById = new Map(apps.map((app) => [app.id, app]));
    const visited = new Set();

    function hasDependency(currentApp) {
        if (!currentApp?.dependencies?.length) return false;

        for (const childAppId of currentApp.dependencies) {
            if (childAppId === dependencyId) {
                return true;
            }

            if (visited.has(childAppId)) {
                continue;
            }

            visited.add(childAppId);

            const childApp = appById.get(childAppId);

            if (hasDependency(childApp)) {
                return true;
            }
        }

        return false;
    }

    return hasDependency(app);
}

export const appSettingsModules = [
    {
        key: "routeplanner",
        schema: RouteplannerSettingsSchema,
        values: RouteplannerSettingsValues,
        Component: RouteplannerSettingsFormFields,
        appliesToApp: () => true,
        scopes: ["app", "location", "task"],
    },
    {
        key: "call_quantum",
        schema: CallQuantumSettingsSchema,
        values: CallQuantumSettingsValues,
        Component: CallQuantumSettingsFormFields,
        appliesToApp: (app, apps) =>
            appDependsOn(app, QUANTUM_EXPORT_APP_ID, apps),
        scopes: ["app", "location", "task"],
    },
    {
        key: "model_runner",
        schema: ModelRunnerSettingsSchema,
        values: ModelRunnerSettingsValues,
        Component: ModelRunnerSettingsFormFields,
        appliesToApp: (app, apps) =>
            appDependsOn(app, MODEL_RUNNER_APP_ID, apps),
        scopes: ["app", "location", "task"],
    },
    {
        key: "upload_name",
        schema: UploadNameSettingsSchema,
        values: UploadNameSettingsValues,
        Component: UploadNameSettingsFormFields,
        appliesToApp: (app, apps) =>
            appDependsOn(app, TRACK32_EXPORT_APP_ID, apps),
        scopes: ["location", "task"],
    },
    {
        key: "cloud_connection",
        schema: CloudConnectionSettingsSchema,
        values: CloudConnectionSettingsValues,
        Component: CloudConnectionSettingsFormFields,
        appliesToApp: () => true,
        scopes: ["location", "task"],
        getExtraProps: ({ cloudConnections }) => ({
            possibleConnections: cloudConnections,
        }),
    },
];
